import { APICore } from './apiCore'

const api = new APICore()

function getDevices (params) {
  const baseUrl = '/devices'
  return api.get(baseUrl, params)
}
function getPlayers () {
  const baseUrl = '/devices/players'
  return api.get(baseUrl, {})
}
function getInteractives () {
  const baseUrl = '/devices/interactives'
  return api.get(baseUrl, {})
}
function getDevice (id) {
  const baseUrl = `/devices/${id}`
  return api.get(baseUrl, {})
}

function addDevice (params) {
  const baseUrl = '/devices'
  return api.create(baseUrl, params)
}
function updateDevice (params) {
  const baseUrl = '/devices'
  return api.update(baseUrl, params)
}
function deleteDevice (params) {
  const baseUrl = '/devices'
  return api.delete(baseUrl, params)
}

export { getDevices, getPlayers, getInteractives, getDevice, addDevice, updateDevice, deleteDevice }